import { FaCalendarDay } from "react-icons/fa6";
import AlertConfigOption from "./AlertConfigOption";
import moment from "moment/moment";
import { useSelector } from "react-redux";
import { useState } from "react";
import AlertTimeModal from "./AlertTimeModal";
import TimezoneSelector from "../../../shared/TimeZoneSelector";
import styles from "../../../styles/Components/alert-system/alert-config/AlertTimeBox.module.css";
import useTimeZone from "../../../hooks/useTimeZone";

function AlertTimeBox() {
  const [showAlertModal, setShowAlertModal] = useState(false);

  const { alertStatus } = useSelector((state) => state.alertSystem);
  const { timeZone } = useTimeZone();

  const alertTime =
    timeZone === "local"
      ? `${moment(alertStatus?.start_time_interval_active).local().format("hh:mm A")} - ${moment(alertStatus?.end_time_interval_active).local().format("hh:mm A")}`
      : `${moment(alertStatus?.start_time_interval_active).utc().format("hh:mm A")} - ${moment(alertStatus?.end_time_interval_active).utc().format("hh:mm A")}`;

  return (
    <AlertConfigOption
      icon={<FaCalendarDay />}
      title="Alert Time"
      onClick={() => setShowAlertModal(true)}
    >
      <div className={styles.timeZoneSelector}>
        <TimezoneSelector />
      </div>

      <p>
        Currently: <span>{alertTime}</span>
      </p>
      {showAlertModal && (
        <AlertTimeModal
          open={showAlertModal}
          onClose={() => setShowAlertModal(false)}
        />
      )}
    </AlertConfigOption>
  );
}

export default AlertTimeBox;
